import {
  IFillDataWizardBuy,
  TBooleanKeysOfIFillDataWizardBuy,
  TKeyOfDataWizardBuy,
  TNumberKeysOfIFillDataWizardBuy,
  TStringKeysOfIFillDataWizardBuy,
} from "../..";
import SelectionByOwnSwapStep_1 from "../selectionByOwnAppSteps/swap/step_1";
import SelectionByOwnSwapStep_2 from "../selectionByOwnAppSteps/swap/step_2";
import SelectionByOwnSwapStep_3 from "../selectionByOwnAppSteps/swap/step_3";
import SelectionByOwnSwapStep_4 from "../selectionByOwnAppSteps/swap/step_4";
import SelectionByOwnSwapStep_5 from "../selectionByOwnAppSteps/swap/step_5";
import SelectionByOwnSwapStep_6 from "../selectionByOwnAppSteps/swap/step_6";
import SelectionByOwnSwapStep_7 from "../selectionByOwnAppSteps/swap/step_7";
import SelectionByOwnSwapStep_8 from "../selectionByOwnAppSteps/swap/step_8";
import SelectionByOwnSwapStep_9 from "../selectionByOwnAppSteps/swap/step_9";
import SelectionByOwnSwapStep_10 from "../selectionByOwnAppSteps/swap/step_10";
import SelectionByOwnSwapStep_11 from "../selectionByOwnAppSteps/swap/step_11";
import SelectionByOwnSwapStep_12 from "../selectionByOwnAppSteps/swap/step_12";
import SelectionByOwnSwapStep_13 from "../selectionByOwnAppSteps/swap/step_13";
import SelectionByOwnSwapStep_14 from "../selectionByOwnAppSteps/swap/step_14";
import SelectionByOwnSwapStep_15 from "../selectionByOwnAppSteps/swap/step_15";
import SelectionByOwnSwapStep_16 from "../selectionByOwnAppSteps/swap/step_16";

const getSelectionByOwnAppSwapSteps = (
  data: IFillDataWizardBuy,
  dataFeatures: Partial<IFillDataWizardBuy>,
  handleChangeDataObject: (data: Partial<IFillDataWizardBuy>) => void,
  handleChangeDataNumber: (
    data: number | number[],
    key: TNumberKeysOfIFillDataWizardBuy
  ) => void,
  handleChangeDataString: (
    data: string,
    key: TStringKeysOfIFillDataWizardBuy
  ) => void,
  handleChangeDataBoolean: (
    data: boolean,
    key: TBooleanKeysOfIFillDataWizardBuy
  ) => void,
  onReset: (key: TKeyOfDataWizardBuy[]) => void,
  disabledAndPrev: {
    isNextStep_dataFeatures: boolean;
    isNextStepDisabled_aim: boolean;
    isNextStepDisabled_finance: boolean;
    isNextStep_communicationType: boolean;
    isNextStep_timeIntervalTypeView: boolean;
    isNextStepDisabled_selectedTypeIds: boolean;
    isNextStepDisabled_apartmentNumber: boolean;
    isNextStep_viewRealtorParticipation: boolean;
    isNextStepDisabled_selectedPolygonIds: boolean;
    isNextStep_timeIntervalTypeCommunication: boolean;
    isDoublePrevSteps: boolean;
    isTriplePrevSteps: boolean;
  }
) => {
  // сценарий выхода на обмен

  const {
    isNextStep_dataFeatures,
    isNextStepDisabled_aim,
    isNextStepDisabled_finance,
    isNextStep_communicationType,
    isNextStep_timeIntervalTypeView,
    isNextStepDisabled_selectedTypeIds,
    isNextStepDisabled_apartmentNumber,
    isNextStep_viewRealtorParticipation,
    isNextStepDisabled_selectedPolygonIds,
    isNextStep_timeIntervalTypeCommunication,
    isDoublePrevSteps,
    isTriplePrevSteps,
  } = disabledAndPrev;

  return [
    <SelectionByOwnSwapStep_1
      onChange={handleChangeDataNumber}
      isNextStepDisabled={isNextStepDisabled_apartmentNumber}
      data={data.apartmentNumber}
      onReset={onReset}
    />,
    <SelectionByOwnSwapStep_2
      onChange={handleChangeDataObject}
      data={dataFeatures}
      isNextStepDisabled={isNextStep_dataFeatures}
      onReset={onReset}
    />,
    <SelectionByOwnSwapStep_3
      buildingId={data.buildingId}
      onChange={handleChangeDataNumber}
      onReset={onReset}
    />,
    <SelectionByOwnSwapStep_4
      isNextStepDisabled={isNextStepDisabled_selectedPolygonIds}
      onChange={handleChangeDataNumber}
      data={data.desiredLocationIds}
      buildingId={data.buildingId}
      onReset={onReset}
    />,
    <SelectionByOwnSwapStep_5
      isNextStepDisabled={isNextStepDisabled_selectedTypeIds}
      onChange={handleChangeDataNumber}
      data={data.selectedFacilityTypeIds}
      doublePrevStep={isDoublePrevSteps}
      onReset={onReset}
    />,
    <SelectionByOwnSwapStep_6
      typeIds={data.selectedFacilityTypeIds}
      selectedPolygonIds={data.desiredLocationIds}
    />,
    <SelectionByOwnSwapStep_7
      isNextStepDisabled={isNextStepDisabled_selectedTypeIds}
      onChange={handleChangeDataNumber}
      data={data.selectedFacilityTypeIds}
      onReset={onReset}
    />,
    <SelectionByOwnSwapStep_8
      typeIds={data.selectedFacilityTypeIds}
      selectedPolygonIds={data.desiredLocationIds}
    />,
    <SelectionByOwnSwapStep_9
      isNextStepDisabled={isNextStepDisabled_finance}
      data={data.finance}
      onChange={handleChangeDataBoolean}
      triplePrevStep={isTriplePrevSteps}
      onReset={onReset}
    />,
    <SelectionByOwnSwapStep_10
      isNextStepDisabled={isNextStepDisabled_aim}
      onChange={handleChangeDataString}
      data={data.aim}
      onReset={onReset}
    />,
    <SelectionByOwnSwapStep_11 />,
    <SelectionByOwnSwapStep_12
      onChange={handleChangeDataString}
      data={data.communicationType}
      isNextStepDisabled={isNextStep_communicationType}
      onReset={onReset}
    />,
    <SelectionByOwnSwapStep_13
      onChange={handleChangeDataString}
      data={data.timeIntervalTypeCommunication}
      isNextStepDisabled={isNextStep_timeIntervalTypeCommunication}
      onReset={onReset}
    />,
    <SelectionByOwnSwapStep_14
      onChange={handleChangeDataString}
      data={data.viewRealtorParticipation}
      isNextStepDisabled={isNextStep_viewRealtorParticipation}
      onReset={onReset}
    />,
    <SelectionByOwnSwapStep_15
      onChange={handleChangeDataString}
      data={data.timeIntervalTypeView}
      isNextStepDisabled={isNextStep_timeIntervalTypeView}
      onReset={onReset}
    />,
    <SelectionByOwnSwapStep_16 data={data} />,
  ];
};

export default getSelectionByOwnAppSwapSteps;
